import { $api } from '#imports'

export const formatVehicleType = (value: string) => {
  switch (value) {
    case 'TRUCK_2000KG':
      return $t('labels.vehicleModule.category.truck2000kg')
    case 'TRUCK_4000KG':
      return $t('labels.vehicleModule.category.truck4000kg')
    case 'TRUCK_10000KG':
      return $t('labels.vehicleModule.category.truck10000kg')
    case 'TRUCK_18000KG':
      return $t('labels.vehicleModule.category.truck18000kg')
    case 'TRUCK_40000KG':
      return $t('labels.vehicleModule.category.truck40000kg')
    case 'TRUCK_OVER_40000KG':
      return $t('labels.vehicleModule.category.truckOver40000kg')
    default:
      return $t('labels.noData')
  }
}
export const formatUseGenset = (value: Boolean) => {
  if (value) {
    return $t('labels.true')
  } else {
    return $t('labels.false')
  }
}
export const formatContainerType = (value: String) => {
  if (value === 'SEPARATED_CONTAINER') {
    return $t('labels.vehicleModule.category.sepataredContainer')
  } else {
    return $t('labels.vehicleModule.category.stickyContainer')
  }
}
export const formatCoveringContainerLevel = (value: String) => {
  if (value === 'PRIVATE') {
    return $t('labels.vehicleModule.private')
  } else if (value === 'OPEN') {
    return $t('labels.vehicleModule.open')
  }
  return $t('labels.noData')
}
export const formatGoodsTypes = (value: Array<String>) => {
  if (value.length > 0) {
    const formatGoodsType = value.map((item: any) => {
      if (item === '') {
        return item
      }
      if (item === 'SOLID') {
        item = $t('labels.vehicleModule.category.solid')
      } else if (item === 'LIQUID') {
        item = $t('labels.vehicleModule.category.liquid')
      } else {
        item = $t('labels.vehicleModule.category.gas')
      }
      return item
    })
    return formatGoodsType.toString()
  }
  return $t('labels.noData')
}
export const formatVehicleStatus = (value: number) => {
  switch (value) {
    case 0:
      return $t('labels.vehicleModule.free')
    case 1:
      return $t('labels.vehicleModule.working')
    case -1:
      return $t('labels.vehicleModule.freeContainer')
    default:
      return ''
  }
}
export const formatAxesRemoocCategory = (value: string) => {
  switch (value) {
    case 'DOUBLE':
      return $t('labels.remoocModule.remoocCategory.double')
    case 'TRIPLE':
      return $t('labels.remoocModule.remoocCategory.triple')
    default:
      return ''
  }
}
export const formatTowingContainer = (value: string) => {
  return value ? $t('labels.remoocModule.remoocCategory.isTowing') : $t('labels.remoocModule.remoocCategory.isNotTowing')
}
export const formatRemoocStatus = (value: number) => {
  switch (value) {
    case 1:
      return $t('labels.remoocModule.active')
    case -1:
      return $t('labels.remoocModule.inactive')
    default:
      return ''
  }
}
export const formatTowingCapacity = (value: Array<number>) => {
  if (value.length > 0) {
    const formatCapacity = value.map((item: any) => {
      if (item === '') {
        return item
      }
      switch (item) {
        case 10:
          item = $t('labels.vehicleModule.10ft')
          break
        case 20:
          item = $t('labels.vehicleModule.20ft')
          break
        case 40:
          item = $t('labels.vehicleModule.40ft')
          break
        case 45:
          item = $t('labels.vehicleModule.45ft')
          break
        case 50:
          item = $t('labels.vehicleModule.other')
          break
        default:
          item = ''
          break
      }
      return item
    })
    return formatCapacity.toString()
  }
  return $t('labels.noData')
}

export const findDrivers = async (s: string) => {
  const api: any = $url.driver.driver.select

  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}
